import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "computerWithAdjustableWrench",
    iconColor: "white",
    text: "Intelligent event correlation and root cause identification",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "graphArrowUpInsideCircle",
    iconColor: "white",
    text: "Predictive maintenance and assurance",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "worldWithScheme",
    iconColor: "white",
    text: "Enhanced network and \nservice availability",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "robotWithLittleBox",
    iconColor: "white",
    text: "Gen-AI driven \noperations",
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_ISNA_2 = {
  title: "Diagnose",
  titleNumber: "2.",
  subtitle:
    "Real-time AI/ML based event correlation, root cause\n identification and metric anomaly detection.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  styleListData: { marginTop: "80px" },
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage("ENG_204"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_202"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/ISNA/ISNA_Introduction_03.png",
  showInfoButton: false,
  modalButton: "Diagnose demo",
  modalImages: [
    "ENG/ISNA/modal/ISNA_MODAL_diagnose_1.png",
    "ENG/ISNA/modal/ISNA_MODAL_diagnose_2.png",
    "ENG/ISNA/modal/ISNA_MODAL_diagnose_3.png",
    "ENG/ISNA/modal/ISNA_MODAL_diagnose_4.png",
  ],
};
